import { useSelector } from 'react-redux';
import { DetachedWindowContext, DEFAULT_DETACHED_WINDOW_CONTEXT_VALUE } from 'conversations-visitor-experience-components/contexts/DetachedWindowContext';
import { getIsUngatedForDetachWidget } from '../widget-data/selectors/widgetDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const DetachedWindowProvider = ({
  children
}) => {
  const isDetachEnabled = useSelector(getIsUngatedForDetachWidget);
  return /*#__PURE__*/_jsx(DetachedWindowContext.Provider, {
    value: Object.assign({}, DEFAULT_DETACHED_WINDOW_CONTEXT_VALUE, {
      isDetachEnabled
    }),
    children: children
  });
};
DetachedWindowProvider.displayName = 'DetachedWindowProvider';